// extracted by mini-css-extract-plugin
module.exports = {"login_wrapper":"LoginModal_login_wrapper__1Ebuj","login_logo":"LoginModal_login_logo__2VnjK"};